<template>
  <div class="row">
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-1">
            <b-row>
              <b-col cols="12" xs="12" md="6" lg="6" xl="6">
                <b-form-group
                  title="1. Hệ đào tạo"
                  label-for="trainingSystemId"
                >
                  <v-select
                    v-model="filter.trainingSystemId"
                    :options="trainingSystemsOptions"
                    :reduce="(option) => option.value"
                    placeholder="1. Hệ đào tạo"
                    @input="onChangeTrainingSystem"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" xs="12" md="6" lg="6" xl="6">
                <b-form-group
                  title="2. Khóa - Học kỳ"
                  label-for="courseSemesterId"
                >
                  <v-select
                    v-model="filter.courseSemesterId"
                    :options="coursesSemestersOptions"
                    :reduce="(option) => option.id"
                    label="name"
                    placeholder="2. Khóa - Học kỳ"
                    @input="onChangeCoursesSemester"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" xs="12" md="6" lg="6" xl="6">
                <b-form-group
                  title="Dự kiến thi"
                  label-for="examinationScheduler"
                >
                  <v-select
                    v-model="filter.examinationSchedulerId"
                    :options="examinationSchedulers"
                    :reduce="(option) => option.id"
                    label="name"
                    placeholder="3. Dự kiến thi"
                    @input="onChangeExaminationScheduler"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" xs="12" md="6" lg="6" xl="6">
                <b-form-group
                  title="4. Học phần"
                  label-for="subjectSelect"
                >
                  <v-select
                    v-model="filter.subjectId"
                    :options="subjects"
                    label="name"
                    :reduce="(option) => option.id"
                    placeholder="4. Học phần"
                    @input="onChangeSubject"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Lớp tín chỉ:"
                  label-for="listCreditClass"
                >
                  <span
                    id="listCreditClass"
                    class="float-left"
                    v-html="showCreditClassList(listCreditClass)"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col
                cols="12"
                xs="6"
                md="3"
                lg="3"
                xl="3"
              >
                <b-form-group
                  title="Ngày bắt đầu"
                  label-for="startDate"
                >
                  <b-form-datepicker
                    id="startDate"
                    v-model="startDate"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    locale="vi"
                    format="dd/mm/yyyy"
                    placeholder="Ngày bắt đầu"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                xs="3"
                md="3"
                lg="3"
                xl="2"
              >
                <b-form-group
                  title="Số lượng phòng"
                >
                  <b-form-input
                    v-model="countRoom"
                    :disabled="isCountStudent === 0 || isExistExaminationRoom > 0 || !creatable"
                    :step="1"
                    min="1"
                    type="number"
                    class="text-bold text-danger"
                    placeholder="Số lượng phòng"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                xs="12"
                md="6"
                lg="6"
                xl="7"
              >
                <div class="text-right">
                  <b-button
                    v-show="isCountStudent > 0 && isExistExaminationRoom === 0 && countRoom > 0 && creatable"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    style="margin-right: 5px"
                    @click="onCreateExaminationRoom"
                  >
                    <span class="text-nowrap text-right"><feather-icon icon="PlusIcon" /> Tạo phòng thi</span>
                  </b-button>
                  <b-button
                    v-show="isExistExaminationRoom !== 0"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mr-1"
                    @click="onSelectExaminationRoom"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="ListIcon" /> Danh sách
                    </span>
                  </b-button>
                  <b-dropdown
                    v-show="examinationRooms.length > 0"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    text="Xuất PDF"
                    right
                    variant="outline-primary"
                  >
                    <b-dropdown-item @click="exportPdfStudentsExaminationRoom">
                      <span class="text-nowrap text-right">
                        <feather-icon icon="FileIcon" /> DS phòng thi
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="exportPdfStudentsExaminationScoreFile">
                      <span class="text-nowrap text-right">
                        <feather-icon icon="FileIcon" /> Phiếu ghi điểm SBD
                      </span>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="12">
                <div class="d-flex align-items-center mb-1 mt-0">
                  <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                    đến {{ (filter.itemsPerPage * (filter.currentPage) >= totalRows)? totalRows : filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                  </span>
                </div>
                <vue-good-table
                  mode="remote"
                  :columns="columns"
                  :rows="examinationRooms"
                  :pagination-options="paginationOptions"
                  :total-rows="totalRows"
                  line-numbers
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>
                  <template
                    slot="table-row"
                    slot-scope="props"
                  >
                    <span v-if="props.column.field === 'stt'">
                      {{ props.row.originalIndex + 1 }}
                    </span>
                    <span v-else-if="props.column.field === 'action'">
                      <b-button-group>
                        <b-button
                          v-if="updatable"
                          v-b-modal.examinationRoomSaveModal
                          variant="primary"
                          class="btn-icon"
                          size="sm"
                          @click="onEditExaminationRoom(props.row)"
                        >
                          <feather-icon icon="Edit2Icon" />
                        </b-button>
                        <b-dropdown
                          right
                          variant="success"
                        >
                          <b-dropdown-item
                            v-if="studentExaminationRoomReadable"
                            variant="success"
                            class="btn-icon"
                            size="sm"
                            @click="onShowsStudentExaminationRoom(props.row)"
                          >
                            <feather-icon icon="UsersIcon" />
                            Danh sách sinh viên
                          </b-dropdown-item>
                          <b-dropdown-item
                            v-if="examInvigilatorReadable"
                            variant="success"
                            class="btn-icon"
                            size="sm"
                            @click="onAssignExamInvigilator(props.row.id)"
                          >
                            <feather-icon icon="UsersIcon" />
                            Phân công coi thi
                          </b-dropdown-item>
                        </b-dropdown>
                        <b-button
                          v-if="deletable"
                          variant="danger"
                          class="btn-icon"
                          size="sm"
                          title="Xóa"
                          @click="onDeleteExaminationRoom(props.row)"
                        >
                          <feather-icon icon="TrashIcon" />
                        </b-button>
                      </b-button-group>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}</span>
                  </template>

                  <!-- pagination -->
                  <template
                    slot="pagination-bottom"
                    slot-scope="props"
                  >
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                          đến {{ (filter.itemsPerPage * (filter.currentPage) >= totalRows)? totalRows : filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                        </span>
                      </div>
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị </span>
                        <b-form-select
                          v-model="filter.itemsPerPage"
                          :options="itemsPerPageOptions"
                          class="mx-1"
                          @input="(value) => props.perPageChanged({ currentPerPage: value })"
                        />
                        <span class="text-nowrap"> bản ghi/trang</span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="totalRows"
                          :per-page="filter.itemsPerPage"
                          class="mt-1 mb-0"
                          @input="(value) => props.pageChanged({ currentPage: value })"
                        />
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
    <examinationRoomSave
      ref="examinationRoomsSaveFormRef"
      :examination-room="currentExaminationRoom"
      @succeed="onSucceed"
    />

    <b-modal
      id="studentExaminationPointModal"
      centered
      :title="`Nhập điểm thi theo phách: ${(currentExaminationRoom)?currentExaminationRoom.name : ''}`"
      size="xl"
      body-class="position-static"
      no-close-on-backdrop
      hide-footer
    >
      <StudentExaminationPoint
        :examination-room-id="currentExaminationRoomId"
        :training-system-id="filter.trainingSystemId"
        :course-semester-id="filter.courseSemesterId"
        :subject-id="filter.subjectId"
      />
    </b-modal>
    <b-modal
      id="studentExaminationRoomModal"
      centered
      :title="`Danh sách sinh viên: ${(currentExaminationRoom)?currentExaminationRoom.name : ''}`"
      size="xl"
      body-class="position-static"
      no-close-on-backdrop
      hide-footer
    >
      <StudentExaminationRoom
        :ext-data="currentExaminationRoom"
      />
    </b-modal>
    <ExaminationRoomTeacher
      :examination-room-id="currentExaminationRoomId"
      :subject-id="filter.subjectId"
    />
  </div>
</template>

<script>
import {
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BContainer,
  BDropdown,
  BDropdownItem,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BModal,
  BOverlay,
  BPagination,
  BRow,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import ExaminationRoomSaveBatch from '@/views/examination-room-batch/ExaminationRoomSaveBatch.vue'
import vSelect from 'vue-select'
import StudentExaminationPoint from '@/views/student-examination-room/StudentExaminationPoint.vue'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import StudentExaminationRoom from '@/views/student-examination-room/StudentExaminationRoom.vue'
import ExaminationRoomTeacher from '@/views/examination-room/examination-room-teacher/ExaminationRoomTeacher.vue'
import { getUser } from '@/auth/utils'
import apiCommon from '@/views/apiCommon'
import apiMain from '@/views/examination-room-batch/api'

export default {
  name: 'ExaminationRoom',
  directives: {
    Ripple,
  },
  components: {
    ExaminationRoomTeacher,
    StudentExaminationPoint,
    StudentExaminationRoom,
    examinationRoomSave: ExaminationRoomSaveBatch,
    BFormGroup,
    BButton,
    BButtonGroup,
    BDropdown,
    BDropdownItem,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    VueGoodTable,
    BFormInput,
    BModal,
    BFormDatepicker,
    vSelect,
  },
  data() {
    return {
      user: getUser(),
      listCreditClass: undefined,
      startDate: new Date().toISOString().split('T')[0],
      isExistExaminationRoom: 0,
      isCountStudent: 0,
      isThiLai: 0,
      isLoading: false,
      countRoom: 1,
      examRoomCount: 0,
      maxStudentRoom: 0,
      currentSelectedRoom: {},
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        code: null,
        name: null,
        subjectId: null,
        status: null,
        sort: null,
        again: 0,
        separate: 0,
        trainingSystemId: null,
        courseSemesterId: null,
        examinationSchedulerId: null,
      },
      currentExaminationRoom: undefined,
      paginationOptions: {
        enabled: true,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      columns: [
        {
          label: 'Tên phòng thi theo học phần',
          field: 'name',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Địa điểm thi',
          field: 'room',
          filterOptions: {
            enabled: false,
            trigger: 'enter',
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Số lượng SV',
          field: 'countStudent',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Sức chứa phòng thi',
          field: 'maxQty',
          filterOptions: {
            enabled: false,
            trigger: 'enter',
          },
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Giám thị',
          field: 'supervisorNum',
          width: '100px',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Bắt đầu',
          field: 'start_at',
          width: '100px',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Kết thúc',
          field: 'end_at',
          width: '100px',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: '',
          field: 'action',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
      currentExaminationRoomId: null,
      trainingSystemsOptions: [],
      coursesSemestersOptions: [],
      subjects: [],
      examinationRooms: [],
      totalRows: 0,
      allTrainingSystems: [],
      coursesSemesters: [],
      courseSemesterSubject: [],
      courseSemesterSubjectThiLai: [],
      examinationSchedulers: [],
      examinationSchedulerSubjects: [],
      examinationSchedulerSubjectDates: [],
      allRoom: [],
      filterGetAllData: {
        currentPage: 1,
        itemsPerPage: 1000000,
        status: 1,
      },
      examRoomsCount: 0,
    }
  },
  computed: {
    examInvigilatorReadable() {
      return hasPermissionForResource(PermissionCode.READ, ResourceCode.EXAMINATION_ROOM_TEACHER)
    },
    creatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.EXAMINATION_ROOM_BATCH)
    },
    updatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.EXAMINATION_ROOM_BATCH)
    },
    deletable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.EXAMINATION_ROOM_BATCH)
    },
    studentExaminationRoomReadable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.READ, ResourceCode.STUDENT_EXAMINATION_ROOM)
    },
  },
  async created() {
    this.isLoading = true
    try {
      this.trainingSystemsOptions = await apiCommon.getTrainingSystems(this.filterGetAllData)
    } catch (e) {
      this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger')
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    isSystemAdmin,
    showToast(title, icon, variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon,
          variant,
        },
      })
    },

    resetExaminationSchedulers() {
      this.reset()
      this.subjects = []
      this.filter.subjectId = null
      this.examinationRooms = []
      this.totalRows = 0
    },

    resetCourseSemesters() {
      this.resetExaminationSchedulers()
      this.examinationSchedulers = []
      this.filter.examinationSchedulerId = null
    },

    resetTrainingSystems() {
      this.resetCourseSemesters()
      this.coursesSemesters = []
      this.filter.courseSemesterId = null
    },

    reset() {
      this.listCreditClass = null
      this.isExistExaminationRoom = 0
      this.isCountStudent = 0
    },

    async onChangeTrainingSystem() {
      this.resetTrainingSystems()
      this.isLoading = true
      try {
        this.coursesSemestersOptions = await apiMain.getCourseSemester({ trainingSystemId: this.filter.trainingSystemId })
      } catch (e) {
        this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger')
      } finally {
        this.isLoading = false
      }
    },

    async onChangeCoursesSemester() {
      this.resetCourseSemesters()
      this.isLoading = true
      try {
        if (this.filter.courseSemesterId) {
          this.examinationSchedulers = await apiMain.getExaminationSchedulers({
            organizationId: getUser().orgId, courseSemesterId: this.filter.courseSemesterId, currentPage: 1, itemsPerPage: 1000000,
          })
        }
      } catch (e) {
        this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger')
      } finally {
        this.isLoading = false
      }
    },

    async onChangeExaminationScheduler() {
      this.resetExaminationSchedulers()
      this.isLoading = true
      try {
        if (this.filter.examinationSchedulerId) {
          this.subjects = await apiMain.getSubjectByExaminationScheduler({ examinationSchedulerId: this.filter.examinationSchedulerId })
        }
      } catch (e) {
        this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger')
      } finally {
        this.isLoading = false
      }
    },

    onChangeSubject() {
      let item = null
      item = this.subjects.find(x => x.id === this.filter.subjectId)
      this.listCreditClass = item?.listCreditClass
      this.isExistExaminationRoom = item?.countExaminationRoom
      this.isCountStudent = item?.countStudent

      if (this.isCountStudent === 0 && this.isExistExaminationRoom === 0) {
        this.showToast(this.isThiLai.toString() === '1' ? 'Không có sinh viên nào cần thi lại môn này!' : 'Không có sinh viên nào đủ điều kiện thi môn này!', 'InfoIcon', 'warning')
      } else {
        this.countRoom = item?.listCreditClass.split(',').length
      }
    },

    async onSelectExaminationRoom() {
      this.isLoading = true
      try {
        const response = await apiMain.getExaminationRooms(this.filter)
        if (response) {
          this.examinationRooms = response?.records
          this.totalRows = response?.total
        }
      } catch (e) {
        this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger')
      } finally {
        this.isLoading = false
      }
    },

    async onCreateExaminationRoom() {
      if (!this.startDate) {
        this.showToast('Ngày bắt đầu không được trống', 'InfoIcon', 'warning')
        return
      }
      const roomNum = this.countRoom
      const subjectName = this.subjects.find(e => e.id === this.filter.subjectId).name
      this.$swal({
        title: `Bạn chắc chắn muốn tạo <span class="text-danger">${roomNum}</span> phòng thi theo học phần <span class="text-danger">${subjectName}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await apiMain.insertExaminationRooms({
              coursesSemesterId: this.filter.courseSemesterId,
              subjectId: this.filter.subjectId,
              countRoom: this.countRoom,
              startDate: this.startDate,
              examinationScheduleId: this.filter.examinationSchedulerId,
            })

            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                this.showToast(message, 'CheckIcon', 'success')
                this.isExistExaminationRoom = 1
                await this.getExaminationRoomsFromStore()
              } else {
                this.showToast(message, 'XCircleIcon', 'danger')
              }
            }
          } catch (e) {
            this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger')
          } finally {
            this.isLoading = false
          }
        }
      })
    },

    onEditExaminationRoom(examinationRoom) {
      const {
        rowNum, originalIndex, vgt_id, ...rest
      } = examinationRoom
      this.currentExaminationRoom = rest
    },

    onDeleteExaminationRoom(examinationRoom) {
      this.$swal({
        title: `Bạn chắc chắn muốn xóa phòng thi theo học phần <span class="text-danger">${examinationRoom.name}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await apiMain.deleteExaminationRoom(examinationRoom.id,)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                this.showToast(message, 'CheckIcon', 'success')
                this.onChangeSubject()
                try {
                  await this.onSelectExaminationRoom()
                } catch (e) {
                  this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger')
                }
              } else {
                this.showToast(message, 'XCircleIcon', 'danger')
              }
            }
          } catch (e) {
            this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger')
          } finally {
            this.isLoading = false
          }
        }
      })
    },

    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },

    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getExaminationRoomsFromStore()
    },

    async getExaminationRoomsFromStore() {
      this.isLoading = true
      try {
        const response = await apiMain.getExaminationRooms(this.filter)
        this.examinationRooms = response?.records || []
        this.totalRows = response?.total || 0
      } catch (e) {
        this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger')
      } finally {
        this.isLoading = false
      }
    },

    async onPerPageChange(param) {
      this.updateParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getExaminationRoomsFromStore()
    },

    async onSortChange(param) {
      if (param.length > 0) {
        const { field, type } = param[0]
        if (field === 'name') this.updateParams({ sort: `1_${type}` })
        else if (field === 'code') this.updateParams({ sort: `2_${type}` })
        else this.updateParams({ sort: `3_${type}` })
      }
      await this.getExaminationRoomsFromStore()
    },

    async onColumnFilter(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'name')) this.updateParams({ name: columnFilters.name })
      if (Object.hasOwn(columnFilters, 'code')) this.updateParams({ code: columnFilters.code })
      if (Object.hasOwn(columnFilters, 'room')) this.updateParams({ room: columnFilters.room })
      if (Object.hasOwn(columnFilters, 'subject')) this.updateParams({ subject: columnFilters.subject })
      if (Object.hasOwn(columnFilters, 'status')) this.updateParams({ status: columnFilters.status })
      await this.getExaminationRoomsFromStore()
    },

    async onSucceed() {
      await this.getExaminationRoomsFromStore()
    },

    showCreditClassList(creditClass) {
      if (creditClass) {
        let htmlList = '<ol class="list list-inline mb-0">'
        try {
          const tmpClasses = creditClass.split(',')
          tmpClasses.forEach(e => {
            htmlList += `<li class="list-inline-item"><span class="badge badge-success">${e}</span></li>`
          })
          htmlList += '</ol>'
        } catch (e) {
          htmlList += '<li class="list-inline-item"><span class="badge badge-dark">Không có dữ liệu</span></li>'
        }
        const htmlCountStudent = (this.isCountStudent) ? `(<u><strong class="text-danger h4">${this.isCountStudent}</strong> Thí sinh</u>)` : ''
        return `${htmlList} ${htmlCountStudent}`
      }
      return ''
    },

    onShowsStudentExaminationRoom(row) {
      const { originalIndex, vgt_id, ...rest } = row
      this.currentExaminationRoom = { ...rest }
      this.$bvModal.show('studentExaminationRoomModal')
    },

    onAssignExamInvigilator(id) {
      this.currentExaminationRoomId = id
      this.$bvModal.show('examinationRoomTeacherModal')
    },

    async exportPdfStudentsExaminationRoom() {
      if (this.examinationRooms.length === 0) {
        this.showToast('Không có dữ liệu để xuất file!', 'InfoIcon', 'warning')
        return
      }
      this.isLoading = true
      try {
        const data = await apiMain.exportStudentsExaminationRoom({
          courseSemesterId: this.filter.courseSemesterId,
          subjectId: this.filter.subjectId,
        })
        if (data) {
          const url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
          window.open(url, '_blank')
        } else {
          this.showToast('File không có dữ liệu', 'XCircleIcon', 'danger')
        }
      } catch (e) {
        this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger')
      } finally {
        this.isLoading = false
      }
    },

    async exportPdfStudentsExaminationScoreFile() {
      if (this.examinationRooms.length === 0) {
        this.showToast('Không có dữ liệu để xuất file!', 'InfoIcon', 'warning')
        return
      }
      this.isLoading = true
      try {
        const data = await apiMain.exportPdfStudentsExaminationScore({
          courseSemesterId: this.filter.courseSemesterId,
          subjectId: this.filter.subjectId,
        })
        if (data) {
          const url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
          window.open(url, '_blank')
        } else {
          this.showToast('File không có dữ liệu', 'XCircleIcon', 'danger')
        }
      } catch (e) {
        this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger')
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
